import CustomSearchDropdown from "../../POP/FileComp5";
import _ from "lodash";
import { useSearchParams } from "react-router-dom";
import React, { useState, useEffect, useCallback } from "react";
import TableCompoenent from "../components/TableCompoenent";
import { FULL_API_BASE_URL } from "../../../Config/Config";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { fetchCourseData } from "../../../Redux/StudentRegistration/courseSlice";
import DropDownCB from "../components/SingleDropdwon";
import FormInputs from "../DummyReportPage/FormInputs";
import dayjs from "dayjs";
import DropDownMultipleSelection from "../components/FieldsComponent";
import DropDownMultipleSearchSelection from "../components/FieldsSearchComponent";
import InterogativeImg from "./../../../Assets/Images/CommanImages/Interogative.png";
import ErrorImg from "./../../../Assets/Images/CommanImages/Error.png";
import { useNavigate } from "react-router-dom";
const mapDataToDropdownFormat = (dataArray, idField, nameField) => {
  // Remove duplicates from the array
  return _.uniqBy(
    dataArray.map((item) => ({
      id: item[idField],
      label: item[nameField],
    })),
    "id"
  );
};

const StudentDPPSummary = ({
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  pauseTimer,
  resumeTimer,
  dataClient,
  setPagePath,
}) => {
  const dispatch = useDispatch();
  const { coursesdata } = useSelector((state) => state.course);
  const [resultsData, setResultsData] = useState([]);
  const [selectedStudentIds, setSelectedStudentIds] = useState([]); // For students

  const [headers, setHeaders] = useState([]);
  // const [chapterData, setChapterData] = useState([]);
  // const [batchData, setBatchData] = useState([]);
  // const [subjectData, setSubjectData] = useState([]);
  const [testnamedata, setTestNameData] = useState([]);
  const [isApplied, setIsApplied] = useState(false);
  const [resetKey, setResetKey] = useState(0);
  // const [selectedBatches, setSelectedBatches] = useState([]);
  // const [selectedDppIds, setSelectedDppIds] = useState([]);
  // const [selectedStudentIds, setSelectedStudentIds] = useState([]); // For students
  const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
  const [isVisible, setIsVisible] = useState(true); // For toggling sections visibility
  const [disabled, setDisabled] = useState(false); // For controlling dropdown disabling
  const [selectedBatchName, setSelectedBatchName] = useState("");
  // const [selectedStudents, setSelectedStudents] = useState([]); // New state for selected students
  // const [studentData, setStudentData] = useState([]); // State to hold fetched students
  const [testname, setTestName] = useState([]); // This will store the fetched DPP names
  const [chapterName, setChapterName] = useState([]);
  const [isExpanded, setIsExpanded] = useState(false); // New state to track the expansion of the table
  // const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [filteredSubjects, setFilteredSubjects] = useState([]);
  const [filteredBatches, setFilteredBatches] = useState([]);
  const [apiData, setApiData] = useState([]);
  // const [selectedChapters, setSelectedChapters] = useState([]);

  const [searchKey, setSearchKey] = useState(""); // State for search key from CustomSearchDropdown
  const [batchData, setBatchData] = useState([]);
  const [subjectData, setSubjectData] = useState([]);
  const [chapterData, setChapterData] = useState([]);
  const [dppData, setDppData] = useState([]);
  const [studentData, setStudentData] = useState([]); // New state for student dropdown
  // const [selectedCourseId, setSelectedCourseId] = useState("");
  const [selectedCourseId, setSelectedCourseId] = useState("");
  const [selectedChapters, setSelectedChapters] = useState([]);
  const [selectedDppIds, setSelectedDppIds] = useState([]);
  const [selectedBatches, setSelectedBatches] = useState([]);
  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [searchColumn, setSearchColumn] = useState(""); // search column
  const [selectedStudents, setSelectedStudents] = useState([]); // New state for selected students
  const [value, setValues] = useState({
    report_title: "",
    course_id: "",
    batch_id: "",
    assessment_id: "",
    assessment_name: "",
    description: "",
    month: "",
    start_month: "",
    month: "Month to Date",
    end_month: "",
    subject_id: [], // Initialize as an empty array
    chapter_id: [], // Initialize as an empty array    month: "",
    start_month: "",
    end_month: "",
    subject_id: [],
    chapter_id: [],
  });

  const [searchParams] = useSearchParams();
  const reportName = searchParams.get("reportName");
  // console.log('Received reportName:', reportName)

  // Modify fetchDropdownData to include selectedCourseId
  useEffect(() => {
    setPagePath(
      "Reports > Reports Dashboard > Practice Paper Completion by Student"
    );
    if (selectedCourseId) {
      fetchDropdownData(); // Call only when selectedCourseId is updated and valid
    }
  }, [selectedCourseId]); // Trigger fetchDropdownData when selectedCourseId changes

  const fetchDropdownData = useCallback(async () => {
    try {
      if (!selectedCourseId) throw new Error("No course selected");

      const response = await fetch(
        `${FULL_API_BASE_URL}/get-dpp-report-filter-searchkey-v2/?course_id=${selectedCourseId}`,
        {
          method: "POST",
          headers: {
            accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            batch_ids: selectedBatches,
            subject_ids: selectedSubjects,
            chapter_ids: selectedChapters,
            assessment_ids: selectedDppIds,
            student_ids: selectedStudents,
            search_key: searchKey,
            search_column: searchColumn,
          }),
        }
      );

      const data = await response.json();

      setBatchData(
        mapDataToDropdownFormat(data.batch_list, "batch_id", "batch_name")
      );
      setSubjectData(
        mapDataToDropdownFormat(data.subject_list, "subject_id", "subject_name")
      );
      // Ensure unique chapters by chapter_id
      const uniqueChapters = _.uniqBy(data.chapter_list, "chapter_id");
      setChapterData(
        uniqueChapters.map((item) => ({
          id: item.chapter_id,
          chapter_name: item.chapter_name, // Field for Chapter Name
          subject_name: item.subject_name, // Field for Subject Name
          // batch_name: item.batch_name, // Field for Batch Name
        }))
      );

      setDppData(
        mapDataToDropdownFormat(
          data.assessment_list,
          "assessment_id",
          "assessment_name"
        )
      );
      const uniqueStudents = _.uniqBy(data.student_list, "student_id");
      setStudentData(
        uniqueStudents.map((item) => ({
          id: item.student_id,
          student_name: item.student_name, // Field for Student Name
          roll_number: item.roll_number, // Field for Roll Number
          batch_name: item.batch_name, // Field for Batch Name
        }))
      );
    } catch (error) {
      console.error("Error fetching dropdown data:", error);
    }
  }, [
    selectedCourseId,
    selectedBatches,
    selectedSubjects,
    selectedChapters,
    selectedDppIds,
    selectedStudents,
    searchKey,
    searchColumn,
  ]);

  const handleDropdownClose = () => {
    fetchDropdownData();
  };
  // Trigger the debounced fetch function when any of the dependencies change
  // useEffect(() => {
  //   fetchDropdownData();
  // }, [
  //   searchKey,
  //   searchColumn,
  //   selectedBatches,
  //   selectedSubjects,
  //   selectedChapters,
  //   selectedDppIds,
  //   selectedStudents,
  //   fetchDropdownData,
  //   selectedCourseId
  // ]);

  const handleSearchKeyChange = (key, dropdownType) => {
    // For Chapter, DPP, and Student, check if at least 3 characters are typed
    if (
      dropdownType === "chapter" ||
      dropdownType === "dpp" ||
      dropdownType === "student"
    ) {
      if (key.length >= 3) {
        setSearchKey(key);
        setSearchColumn(dropdownType); // Use either 'chapter', 'dpp', or 'student'
      } else {
        setSearchKey(""); // Before 3 characters, do not search
        setSearchColumn("");
      }
    } else {
      // For other dropdowns (Batch, Subject, etc.), set searchKey and searchColumn to null
      setSearchKey("");
      setSearchColumn("");
    }
  };

  useEffect(() => {
    dispatch(fetchCourseData());
  }, [dispatch]);

  const calculateDates = () => {
    const today = dayjs();
    let from_date = "";
    let end_date = today.format("YYYY-MM-DD HH:mm:ss");

    switch (value.month) {
      case "Last Month":
        from_date = today
          .subtract(1, "month")
          .startOf("month")
          .format("YYYY-MM-DD HH:mm:ss");
        end_date = today
          .subtract(1, "month")
          .endOf("month")
          .format("YYYY-MM-DD HH:mm:ss");
        break;
      case "Month to Date":
        from_date = today.startOf("month").format("YYYY-MM-DD HH:mm:ss");
        break;
      case "Week to Date":
        from_date = today.startOf("week").format("YYYY-MM-DD HH:mm:ss");
        break;
      case "Custom":
        const current_time = today.format("HH:mm:ss");
        from_date = `${value.start_month} 00:00:00`;
        end_date = `${value.end_month} ${current_time}`;
        break;
      default:
        break;
    }
    return { from_date, end_date };
  };

  const { from_date, end_date } = calculateDates();

  const handleApplyOrReset = async () => {
    if (isApplied) {
      // Reset only non-essential fields while keeping the selected filters
      setResultsData([]); // Clear the table data
      setHeaders([]); // Clear the headers
      setIsApplied(false); // Set the state to not applied
      setIsColumnDivVisible(false); // Hide the column div if necessary
      setDisabled(false); // Enable dropdowns
      setResetKey((prevKey) => prevKey + 1); // Trigger key change to reset components

      // Retain the selected course, batch, chapter, subject, and date values
      setValues((prevValues) => ({
        ...prevValues,
        report_title: "",
        assessment_id: "",
        assessment_name: "",
        description: "",
        // Keep course, batch, chapter, subject, and date fields unchanged
        month: prevValues.month,
        start_month: prevValues.start_month,
        end_month: prevValues.end_month,
        course_id: prevValues.course_id,
        batch_id: prevValues.batch_id,
        subject_id: prevValues.subject_id,
        chapter_id: prevValues.chapter_id,
      }));
    } else {
      // Apply logic
      setIsApplied(true);
      setDisabled(true); // Disable dropdowns

      // Fetch the DPP Performance Data using selected filters
      const { from_date, end_date } = calculateDates(); // Use the calculateDates function to get date range

      if (!selectedCourseId) {
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div
            className="Container-messageBOX"
            onMouseEnter={pauseTimer}
            onMouseLeave={resumeTimer}
          >
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>Please Select a Course</span>
            </div>
          </div>
        );
        setActiveImg(InterogativeImg);
        return;
      }

      const requestBody = {
        // course_id: selectedCourseId || null, // Selected course ID
        batch_ids: selectedBatches || [], // Selected batch IDs
        subject_ids: selectedSubjects || [], // Selected subject IDs
        chapter_ids: selectedChapters || [], // Selected chapter IDs
        // student_ids: selectedStudents.map(student => student.id) || [], // Selected student IDs
        student_ids: selectedStudents || [],
        // from_date: from_date, // Start date
        // end_date: end_date, // End date
      };

      try {
        // const response = await fetch(`${FULL_API_BASE_URL}/get-student-dpp-report-summary`, {
        const response = await fetch(
          `${FULL_API_BASE_URL}/get-student-dpp-report-summary?course_id=${selectedCourseId}&from_date=${encodeURIComponent(
            from_date
          )}&end_date=${encodeURIComponent(end_date)}`,
          {
            method: "POST",
            headers: {
              accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody), // Send selected values in the request body
          }
        );

        const data = await response.json();
        if (data && data.length > 0) {
          setHeaders(data[0]); // Set headers
          setResultsData(data.slice(1)); // Set results
        } else {
          setResultsData([]);
          setIsMessageBoxVisible(true);
          setMessageBox(
            <div
              className="Container-messageBOX"
              onMouseEnter={pauseTimer}
              onMouseLeave={resumeTimer}
            >
              <div className="messagebox-insider1">
                <div className="loader-tc"></div>
                <span>No report data found for the selected filters.</span>
              </div>
            </div>
          );
          setActiveImg(InterogativeImg);
        }
      } catch (error) {
        setResultsData([]);
        setIsMessageBoxVisible(true);
        setMessageBox(
          <div
            className="Container-messageBOX"
            onMouseEnter={pauseTimer}
            onMouseLeave={resumeTimer}
          >
            <div className="messagebox-insider1">
              <div className="loader-tc"></div>
              <span>{error.message}</span>
            </div>
          </div>
        );
        setActiveImg(InterogativeImg);
      }
    }
  };

  const dropdownStyle = isApplied
    ? { opacity: 0.5, pointerEvents: "none" }
    : { opacity: 1, pointerEvents: "auto" };
  const navigate = useNavigate();

  const maxChapterLength = 136;
  const chapter = (() => {
    // If no chapters are selected, assume "All" chapters are selected
    if (
      value.chapter_id.length === 0 ||
      value.chapter_id.length === chapterName.length
    ) {
      return "All"; // Case when no chapters or all chapters are selected
    }

    // Get the full chapter string by joining selected chapters (if chapters are selected)
    const chapterString = chapterName
      .filter((chapter) => value.chapter_id.includes(chapter.id))
      .map((chapter) => chapter.label)
      .join(", ");

    if (chapterString.length > maxChapterLength) {
      // If the string exceeds the limit, show "Multiple"
      return "Multiple";
    } else {
      // If the length is within the limit, return the full string
      return chapterString;
    }
  })();

  const maxStudentLength = 129;
  const student = (() => {
    if (
      selectedStudents.length === 0 ||
      selectedStudents.length === studentData.length
    ) {
      return "All";
    }
    const studentString = selectedStudents
      .map((student) => `${student.roll_no}`)
      .join(", ");

    if (studentString.length > maxStudentLength) {
      return "Multiple";
    } else {
      return studentString;
    }
  })();

  const maxDppLength = 136;
  const dppName = (() => {
    if (
      selectedDppIds.length === 0 ||
      selectedDppIds.length === testname.length
    ) {
      return "All";
    }
    const dppString = testname
      .filter((dpp) => selectedDppIds.includes(dpp.id))
      .map((dpp) => dpp.label)
      .join(", ");

    if (dppString.length > maxDppLength) {
      return "Multiple";
    } else {
      return dppString;
    }
  })();

  const maxSubjectLength = 136;
  const subject = (() => {
    if (
      value.subject_id.length === 0 ||
      value.subject_id.length === subjectData.length
    ) {
      return "All";
    }

    const subjectString = subjectData
      .filter((subject) => value.subject_id.includes(subject.id))
      .map((subject) => subject.label)
      .join(", ");

    if (subjectString.length > maxSubjectLength) {
      return "Multiple";
    } else {
      return subjectString;
    }
  })();

  return (
    <div
      style={{
        height: "auto",
        width: "100%",
        paddingLeft: "36.5px",
        marginBottom: "40px",
      }}
    >
      <div style={{ position: "sticky", top: "0" }}>
        <div className="Header-up">
          <span
            style={{
              color: "#2F2E40",
              fontSize: "30px",
              textTransform: "capitalize",
            }}
          >
            {reportName}
          </span>
          <div
            className="testreportcard-header-btn-container"
            style={{ marginRight: "30px" }}
          >
            <button
              className="testreportcard-cancel-btn"
              // onClick={handleCancel}
              onClick={() => {
                navigate("/report_management");
              }}
            >
              CANCEL
            </button>

            <button
              className="testreportcard-create-btn"
              onClick={handleApplyOrReset}
            >
              {isApplied ? "RESET" : "APPLY"}
            </button>
          </div>
        </div>
      </div>
      <div style={{ display: isVisible ? "block" : "none", marginTop: "1vh" }}>
        <div className="row-cs-uni">
          <div
            className="col-cs2"
            style={{ marginRight: "1vw", ...dropdownStyle }}
            key={`course_${resetKey}`}
          >
            <DropDownCB
              label="Coursee"
              style={{ width: "13.5vw" }}
              selected={selectedCourseId}
              setSelected={setSelectedCourseId}
              options={
                coursesdata
                  ? coursesdata.map((course) => ({
                      id: course.course_id,
                      label: course.course_description,
                    }))
                  : []
              }
            />
          </div>
          <div
            className="col-cs2"
            style={{ marginRight: "1vw", ...dropdownStyle }}
            key={`batch_${resetKey}`}
          >
            {/* <DropDownMultipleSelection
              label="Batch"
              width="13.5vw"
              selected={selectedBatches}
              setSelected={setSelectedBatches}
              options={filteredBatches} // Filtered batch data
              showSelectAll={true}
            /> */}
            <DropDownMultipleSelection
              label="Select Batch"
              width="13vw"
              selected={selectedBatches}
              setSelected={setSelectedBatches}
              options={batchData}
              showSelectAll={true}
              onDropdownClose={handleDropdownClose} // API call after dropdown closes
              isRequired={false}
            />
          </div>
          <div
            className="col-cs2"
            style={{ marginRight: "1vw", ...dropdownStyle }}
            key={`student_${resetKey}`}
          >
            <CustomSearchDropdown
              label="Select Student"
              optionsData={studentData}
              selected={selectedStudents}
              setSelected={setSelectedStudents}
              placeholder="Search for Students..."
              headers={["Student Name", "Roll Number", "Batch Name"]}
              optionFields={{
                option1: "student_name",
                option2: "roll_number",
                option3: "batch_name",
              }}
              onDropdownClose={handleDropdownClose} // API call after dropdown closes
              customwidth="20vw"
            />
          </div>
        </div>
        <div className="row-cs-uni" style={{ marginTop: "1vh" }}>
          <div
            className="col-cs2"
            style={{ marginRight: "1vw", ...dropdownStyle }}
            key={`subject_${resetKey}`}
          >
            <DropDownMultipleSelection
              width="13.5vw"
              label="Select Subject"
              selected={selectedSubjects}
              setSelected={setSelectedSubjects}
              options={subjectData}
              customWidth="100%"
              isRequired={false}
              showSelectAll={true}
              onDropdownClose={handleDropdownClose}
            />
          </div>
          <div
            className="col-cs2"
            style={{ marginRight: "1vw", ...dropdownStyle }}
            key={`chapter_${resetKey}`}
          >
            {/* <DropDownMultipleSearchSelection
              label="Chapter"
              width="13.5vw"
              customWidth="25vw"
              selected={value.chapter_id}
              setSelected={(selectedOptions) => {
                const selectedChapterDetails = chapterData.filter((chapter) =>
                  selectedOptions.includes(chapter.id)
                );
                setValues({
                  ...value,
                  chapter_id: selectedOptions, // Store the selected chapter IDs
                });
              }}
              fetchOptions={fetchChaptersBySubject}
              options={chapterData || []} // Display the chapter data
              showSelectAll={true}
            /> */}
            <CustomSearchDropdown
              label="Select Chapter"
              optionsData={chapterData}
              selected={selectedChapters}
              setSelected={setSelectedChapters}
              placeholder="Search for Chapter..."
              headers={["Chapter Name", "Subject Name"]}
              optionFields={{
                option1: "chapter_name",
                option2: "subject_name",
                // option3: "batch_name",
              }}
              onDropdownClose={handleDropdownClose} // API call after dropdown closes
              customwidth="20vw"
            />
          </div>
          <div
            className="col-cs2"
            style={{ marginRight: "1vw", ...dropdownStyle }}
            key={`dpp_${resetKey}`}
          ></div>
        </div>
        <div
          className="grid-container-radio-button"
          style={{ marginTop: "1vh", height: "35px", ...dropdownStyle }}
        >
          <div className="item5">
            <div className="toggle-radio">
              <input
                type="radio"
                id="last month"
                name="month"
                value="Last Month"
                checked={value.month === "Last Month"}
                onChange={(e) => setValues({ ...value, month: e.target.value })}
                disabled={isApplied}
              />
              <label htmlFor="last month">Previous Month</label>
            </div>
          </div>
          <div className="item6">
            <div className="toggle-radio">
              <input
                type="radio"
                id="month to date"
                name="month"
                value="Month to Date"
                checked={value.month === "Month to Date"} // Ensures "Month to Date" is selected by default
                onChange={(e) => setValues({ ...value, month: e.target.value })}
                disabled={isApplied}
              />
              <label htmlFor="month to date">Month to Date</label>
            </div>
          </div>
          <div className="item7">
            <div className="toggle-radio">
              <input
                type="radio"
                id="week to date"
                name="month"
                value="Week to Date"
                checked={value.month === "Week to Date"}
                onChange={(e) => setValues({ ...value, month: e.target.value })}
                disabled={isApplied}
              />
              <label htmlFor="week to date">Week to Date</label>
            </div>
          </div>
          <div className="item8">
            <div className="toggle-radio">
              <input
                type="radio"
                id="custom"
                name="month"
                value="Custom"
                checked={value.month === "Custom"}
                onChange={(e) => setValues({ ...value, month: e.target.value })}
                disabled={isApplied}
              />
              <label htmlFor="custom">Custom</label>
            </div>
          </div>
          {value.month === "Custom" && (
            <>
              <div className="item9">
                <FormInputs
                  type="date"
                  name="start_month"
                  value={value.start_month}
                  onChange={(e) =>
                    setValues({ ...value, start_month: e.target.value })
                  }
                  disabled={isApplied}
                />
              </div>
              <div className="item10">To</div>
              <div className="item11">
                <FormInputs
                  type="date"
                  name="end_month"
                  value={value.end_month}
                  onChange={(e) =>
                    setValues({ ...value, end_month: e.target.value })
                  }
                  disabled={isApplied}
                />
              </div>
            </>
          )}
        </div>
      </div>
      <div style={{ position: "relative", marginTop: "20px" }}>
        <button
          style={{
            position: "absolute",
            top: "-1px",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 1,
            width: "60px",
            height: "10px",
            backgroundColor: "white",
            border: "none",
          }}
          onClick={() => {
            setIsExpanded(!isExpanded); // Toggle the isExpanded state when clicked
            setIsVisible(!isVisible);
          }}
        >
          <p style={{ fontSize: "20px", color: "black" }}>...</p>
        </button>
        <TableCompoenent
          headers={headers.map((header) => header.substring(2))}
          data={resultsData}
          searchPlaceholder="Search by Student Name..."
          isColumnDivVisible={isColumnDivVisible}
          setIsColumnDivVisible={setIsColumnDivVisible}
          dataClient={dataClient}
          ReportPageHeader="Student DPP Performance"
          course={
            coursesdata?.find((course) => course.course_id === value.course_id)
              ?.course_description || ""
          }
          batch={selectedBatchName}
          student={student}
          subject={subject}
          dppName={dppName}
          date={
            from_date &&
            end_date &&
            dayjs(from_date).isValid() &&
            dayjs(end_date).isValid()
              ? `${dayjs(from_date).format("YYYY-MM-DD")} To ${dayjs(
                  end_date
                ).format("YYYY-MM-DD HH:mm:ss")}`
              : ""
          }
          chapter={chapter}
          isExpanded={isExpanded} // Pass the new isExpanded prop
        />
      </div>
    </div>
  );
};

export default StudentDPPSummary;
